// Config
import supportedCreditCardTypes from '@constants/supportedCreditCardTypes';
import { isClickAndCollectChoice } from '@utils/delivery/deliveryHelper';
import { deepEqual, isEmptyObject } from '@utils/object';

export const SAVED_CARD_DETAILS_FORM_ID = 'savedCardDetailsForm';

export const cvvSkipVariants = {
  ALL_CLICK_AND_COLLECT: 'all_click_and_collect',
  NEW_CLICK_AND_COLLECT: 'new_click_and_collect',
  ALL_TRANSACTIONS: 'all_transactions',
};

export function canSkipCVV({
  cardType,
  selectedDeliveryChoiceId,
  selectedBillingAddress,
  confirmedDeliveryAddress,
  reduceSavedCardCvvSkipEnabled,
  reducedSavedCardCvvSkipVariant,
  isSelectedCollectionPointInSavedPoints,
  addressModified,
  billingAddressRecentlyUpdated,
  deliveryAddressRecentlyUpdated,
}) {
  if (cardType === supportedCreditCardTypes.AMERICAN_EXPRESS || addressModified) {
    return false;
  }

  // If either address was recently updated, require CVV
  if (billingAddressRecentlyUpdated || deliveryAddressRecentlyUpdated) {
    return false;
  }

  if (reduceSavedCardCvvSkipEnabled) {
    switch (reducedSavedCardCvvSkipVariant) {
      case cvvSkipVariants.ALL_CLICK_AND_COLLECT:
        // For 'all_click_and_collect', CVV cannot be skipped for any click and collect delivery choice.
        if (isClickAndCollectChoice(selectedDeliveryChoiceId)) {
          return false;
        }
        break;
      case cvvSkipVariants.NEW_CLICK_AND_COLLECT:
        // Require CVV for new collection points in click and collect deliveries
        if (isClickAndCollectChoice(selectedDeliveryChoiceId) && !isSelectedCollectionPointInSavedPoints) {
          return false;
        }
        break;
      case cvvSkipVariants.ALL_TRANSACTIONS:
        // For 'all_transactions', CVV can never be skipped.
        return false;
      default:
        // If there is no variant or the variant is unrecognized, proceed to the default behavior.
        break;
    }
  }

  if (isClickAndCollectChoice(selectedDeliveryChoiceId)) {
    return true;
  }

  const addressesExist = !isEmptyObject(selectedBillingAddress) && !isEmptyObject(confirmedDeliveryAddress);
  const addressesMatch = deepEqual(selectedBillingAddress, confirmedDeliveryAddress);

  if (addressesExist && addressesMatch) {
    return true;
  }

  return false;
}
